import { DashboardActionTypes } from './constants';
import { ICreateDashboardPayload, IUpdateDashboardPayload } from 'helpers/api/dashboard';

export type DashboardActionType = {
    type:
        | DashboardActionTypes.API_RESPONSE_SUCCESS
        | DashboardActionTypes.API_RESPONSE_ERROR
        | DashboardActionTypes.GET_DASHBOARDS
        | DashboardActionTypes.GET_DASHBOARD_BY_ID
        | DashboardActionTypes.CREATE_DASHBOARD
        | DashboardActionTypes.UPDATE_DASHBOARD
        | DashboardActionTypes.DELETE_DASHBOARD
        | DashboardActionTypes.RESET;
    payload: {} | string;
};

// Common success
export const dashboardApiResponseSuccess = (actionType: string, data: any): DashboardActionType => ({
    type: DashboardActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

// Common error
export const dashboardApiResponseError = (actionType: string, error: string): DashboardActionType => ({
    type: DashboardActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

// Get latest dashboard (or list)
export const getDashboards = (): DashboardActionType => ({
    type: DashboardActionTypes.GET_DASHBOARDS,
    payload: {},
});

// Get dashboard by ID (full detail)
export const getDashboardById = (id: number): DashboardActionType => ({
    type: DashboardActionTypes.GET_DASHBOARD_BY_ID,
    payload: { id },
});

// Create dashboard
export const createDashboard = (data: ICreateDashboardPayload): DashboardActionType => ({
    type: DashboardActionTypes.CREATE_DASHBOARD,
    payload: data,
});

// Update dashboard
export const updateDashboard = (id: number, data: IUpdateDashboardPayload): DashboardActionType => ({
    type: DashboardActionTypes.UPDATE_DASHBOARD,
    payload: { id, data },
});

// Delete dashboard
export const deleteDashboard = (id: number): DashboardActionType => ({
    type: DashboardActionTypes.DELETE_DASHBOARD,
    payload: { id },
});

// Reset state
export const resetDashboards = (): DashboardActionType => ({
    type: DashboardActionTypes.RESET,
    payload: {},
});
